import { render } from "./dots.vue?vue&type=template&id=5b0e5f43"
import script from "./dots.vue?vue&type=script&lang=js"
export * from "./dots.vue?vue&type=script&lang=js"

import "./dots.vue?vue&type=style&index=0&id=5b0e5f43&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__